import React from "react";

const NotFound = () => {
  return (
    <main style={{ height: '100%' }}>Not Found</main>
  )
}
export default NotFound;